import { useState, useEffect } from "react";
import {
  Typography,
  Button,
  TextField,
  Box,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Divider,
  Autocomplete,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useStyles } from "../../assets/styles/Theme";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import ViewDataGridGrn from "../grid/ViewDataGridGrn";
import { supplierBranchData } from "../grid/GridDataGrn";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import dayjs from "dayjs";
import { CON_STATUS_ACTIVE } from "../../utils/sys/Constants";
import { externalpostApi, externalgetApi } from "../../services/externalApis";
import SystemAlert from "../../components/common/SystemAlert";
import { useSelector } from "react-redux";
import {
  SETTING_API_04,
  SETTING_API_12,
  SUPPLIER_API_01,
  SUPPLIER_API_02,
  SUPPLIER_API_05,
  SUPPLIER_API_06,
} from "../../api/ApiModel";
function SupplierBasicInfo({
  supplierType,
  selectedItem,
  actionText,
  setSuprefcode,
  suprefcode,
}) {
  const theme = useTheme();
  const styles = useStyles(theme);
  const navigate = useNavigate();
  const [error, setError] = useState({});
  const [errorsup, setErrorsup] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false); // State to control alert visibility
  const [alertType, setAlertType] = useState("success"); // Type of alert (e.g., success, error, warning)
  const [alertMessage, setAlertMessage] = useState("");
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const SYS_USER = useSelector((state) => state.user) || {};
  const { STAFFMAPLOCODE, USERNAME, COMPCODE } = SYS_USER.USER_PARAM || {};
  const [data, setData] = useState(null);
  const [dataindustry, setDataindustry] = useState(null);
  const [dataidentity, setDataidentity] = useState(null);
  const [datasupbranch, setDatasupbranch] = useState(null);
  const isEdit = actionText === "Edit";
  const [datacountrty, setDatacountry] = useState(null);
  const titleOptions = [
    { label: "Mr.", value: "Mr." },
    { label: "Ms.", value: "Ms." },
  ];

  function formatAllDates(item) {
    // List all your date fields here
    const dateFields = [
      "dateofbusreg",
      "expdate",
      "copdate",
      "endate",
      // add more if needed
    ];
    const formatted = { ...item };
    dateFields.forEach((field) => {
      if (item[field]) {
        formatted[field] = dayjs(item[field]).format("YYYY-MM-DD");
      }
    });
    return formatted;
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await externalgetApi(SETTING_API_12, "get", {});

        setDatacountry(result);
        console.log("result", result);
        setIsLoading(false);
      } catch (err) {
        setError(err);
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  // Define your country options at the top of your file
  const countryOptions = datacountrty
    ? datacountrty.map((item) => ({
        label: item.country,
        value: item.countrycode,
      }))
    : [];

  // 1. Map options
  const identityTypeOptions = dataidentity
    ? dataidentity.map((item) => ({
        label: item.identitytype,
        value: String(item.identitycode),
      }))
    : [];

  // After identityTypeOptions is defined
  useEffect(() => {
    if (
      identityTypeOptions.length > 0 &&
      !selectedItem &&
      !selectedItemDetails.identitycode
    ) {
      setSelectedItemDetails((prev) => ({
        ...prev,
        identitycode: identityTypeOptions[0].value,
        identitytype: identityTypeOptions[0].label,
      }));
    }
    // eslint-disable-next-line
  }, [identityTypeOptions]);

  const [selectedItemDetails, setSelectedItemDetails] = useState({
    suprefcode: "",
    suptitle: "",
    firstname: "",
    lastname: "",
    initialname: "",
    middlename: "",
    email: "",
    mobileno: "",

    identityno: "",

    addresslinE1: "",
    addresslinE2: "",
    addresslinE3: "",
    city: "",
    country: "",

    isvat: "",
    tino: "",
    vatno: "",
    contactno: "",
    contactperson: "",

    province: "",

    suptypecode: "",

    faxno: "",
    descrip: "",

    companyname: "",
    industryname: "",
    industrycode: "1",

    busregno: "",
    dateofbusreg: "",
    identitycode:
      identityTypeOptions.length > 0 ? identityTypeOptions[0].value : "",
    identitytype:
      identityTypeOptions.length > 0 ? identityTypeOptions[0].label : "",
    expdate: dayjs().format("YYYY-MM-DD"),
    contactpersonceo: "",
    emailceo: "",
    mobileceo: "",
    contactpersonpro: "",
    emailpro: "",
    mobilepro: "",
    contactpersonpay: "",
    emailpay: "",
    mobilepay: "",
    copdate: dayjs().format("YYYY-MM-DD"),
  });

  useEffect(() => {
    fetchDatasupbranch();
  }, [selectedItemDetails.suprefcode]);

  useEffect(() => {
    if (selectedItem) {
      const formattedItem = formatAllDates(selectedItem);
      setSelectedItemDetails({
        ...formattedItem,
        suprefcode: selectedItem.suprefcode,
        suptitle: selectedItem.suptitle,
        firstname: selectedItem.firstname,
        lastname: selectedItem.lastname,
        initialname: selectedItem.initialname,
        email: selectedItem.email,
        mobileno: selectedItem.mobileno,
        middlename: selectedItem.middlename || "",
        identityno: selectedItem.identityno || "",
        identitytype: selectedItem.identitytype || "",
        addresslinE1: selectedItem.addresslinE1 || "",
        addresslinE2: selectedItem.addresslinE2 || "",
        addresslinE3: selectedItem.addresslinE3 || "",
        city: selectedItem.city || "",
        expdate: selectedItem.expdate || "",
        isvat: selectedItem.isvat || "",
        tino: selectedItem.tino || "",
        vatno: selectedItem.vatno || "",
        contactno: selectedItem.contactno || "",
        contactperson: selectedItem.contactperson || "",
        province: selectedItem.province || "",
        country: selectedItem.country,

        companyname: selectedItem.companyname || "",
        industryname: selectedItem.industryname || "",
        industrycode: String(selectedItem.industrycode) || "1",
        busregno: selectedItem.busregno || "",

        identitycode: selectedItem.identitycode || 1,
        contactpersonceo: selectedItem.contactpersonceo || "",
        emailceo: selectedItem.emailceo || "",
        mobileceo: selectedItem.mobileceo || "",
        contactpersonpro: selectedItem.contactpersonpro || "",
        emailpro: selectedItem.emailpro || "",
        mobilepro: selectedItem.mobilepro || "",
        contactpersonpay: selectedItem.contactpersonpay || "",
        emailpay: selectedItem.emailpay || "",
        mobilepay: selectedItem.mobilepay || "",
        dateofbusreg: selectedItem.dateofbusreg
          ? dayjs(selectedItem.dateofbusreg).format("YYYY-MM-DD")
          : "",
        copdate: selectedItem.copdate
          ? dayjs(selectedItem.copdate).format("YYYY-MM-DD")
          : dayjs().format("YYYY-MM-DD"),
      });
    }
  }, [selectedItem]);
  console.log("selectedItemDetails", selectedItemDetails);
  const isBranchDisabled = selectedItemDetails.suprefcode === 0;
  const [selectedbranch, setSelectedbranch] = useState({
    branchname: "",
    addresslinE1: "",
    addresslinE2: "",
    addresslinE3: "",
    country: "",
    province: "",
    city: "",
    contactno: "",
    descrip: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const trimmedValue = typeof value === "string" ? value.trim() : value;

    // Prevent initial space only
    if (typeof value === "string" && value.length === 1 && value[0] === " ") {
      return;
    }

    // Validate max length
    if (typeof value === "string" && value.length > 30) {
      setError((prevError) => ({
        ...prevError,
        [name]: "Input cannot exceed 30 characters.",
      }));
      return;
    }

    // Email validation
    if (
      name === "email" ||
      name === "emailpay" ||
      name === "emailpro" ||
      name === "emailceo"
    ) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (trimmedValue === "") {
        setError((prevError) => ({
          ...prevError,
          [name]: "Email cannot be empty.",
        }));
      } else if (!emailRegex.test(trimmedValue)) {
        setError((prevError) => ({
          ...prevError,
          [name]: "Invalid email format.",
        }));
      } else {
        setError((prevError) => ({
          ...prevError,
          [name]: "",
        }));
      }
    } else if (
      name === "mobileno" ||
      name === "contactno" ||
      name === "mobileceo" ||
      name === "mobilepro" ||
      name === "mobilepay"
    ) {
      // Only allow numbers and max 10 digits
      let numericValue = value.replace(/\D/g, ""); // Remove non-digits
      if (numericValue.length > 10) {
        numericValue = numericValue.slice(0, 10); // Limit to 10 digits
      }

      if (numericValue === "") {
        setError((prevError) => ({
          ...prevError,
          [name]: "Phone number cannot be empty.",
        }));
      } else if (numericValue.length < 10) {
        setError((prevError) => ({
          ...prevError,
          [name]: "Phone number must be 10 digits.",
        }));
      } else {
        setError((prevError) => ({
          ...prevError,
          [name]: "",
        }));
      }

      setSelectedItemDetails((prevDetails) => ({
        ...prevDetails,
        [name]: numericValue,
      }));
      return; // Stop further processing
    }
    // Validate empty string for other fields
    else if (typeof value === "string" && trimmedValue === "") {
      setError((prevError) => ({
        ...prevError,
        [name]: "Input cannot be empty or just spaces.",
      }));
    } else {
      setError((prevError) => ({
        ...prevError,
        [name]: "",
      }));
    }

    // Always update the value
    setSelectedItemDetails((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));
  };

  const handleBranchInputChange = (e) => {
    const { name, value } = e.target;
    const trimmedValue = typeof value === "string" ? value.trim() : value;

    // Prevent initial space only
    if (typeof value === "string" && value.length === 1 && value[0] === " ") {
      return;
    }

    // Validate max length
    if (typeof value === "string" && value.length > 30) {
      setErrorsup((prevError) => ({
        ...prevError,
        [name]: "Input cannot exceed 30 characters.",
      }));
      return;
    }

    // Email validation
    if (name === "email") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (trimmedValue === "") {
        setErrorsup((prevError) => ({
          ...prevError,
          [name]: "Email cannot be empty.",
        }));
      } else if (!emailRegex.test(trimmedValue)) {
        setErrorsup((prevError) => ({
          ...prevError,
          [name]: "Invalid email format.",
        }));
      } else {
        setErrorsup((prevError) => ({
          ...prevError,
          [name]: "",
        }));
      }
    }
    // Phone number validation (for fields named 'mobileno' or 'contactno')
    else if (name === "mobileno" || name === "contactno") {
      // Only allow numbers and max 10 digits
      let numericValue = value.replace(/\D/g, ""); // Remove non-digits
      if (numericValue.length > 10) {
        numericValue = numericValue.slice(0, 10); // Limit to 10 digits
      }

      if (numericValue === "") {
        setErrorsup((prevError) => ({
          ...prevError,
          [name]: "Phone number cannot be empty.",
        }));
      } else if (numericValue.length < 10) {
        setErrorsup((prevError) => ({
          ...prevError,
          [name]: "Phone number must be 10 digits.",
        }));
      } else {
        setErrorsup((prevError) => ({
          ...prevError,
          [name]: "",
        }));
      }

      setSelectedbranch((prevDetails) => ({
        ...prevDetails,
        [name]: numericValue,
      }));
      return; // Stop further processing
    }
    // Validate empty string for other fields
    else if (typeof value === "string" && trimmedValue === "") {
      setErrorsup((prevError) => ({
        ...prevError,
        [name]: "Input cannot be empty or just spaces.",
      }));
    } else {
      setErrorsup((prevError) => ({
        ...prevError,
        [name]: "",
      }));
    }

    // Always update the value
    setSelectedbranch((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));
  };

  const [fileName, setFileName] = useState("No file selected");

  const handleFileChange = (event) => {
    if (event.target.files.length > 0) {
      setFileName(event.target.files[0].name);
    } else {
      setFileName("No file selected");
    }
  };

  const [filteredRows, setFilteredRows] = useState(supplierBranchData.rows);

  // Add this state to track edit mode
  const [isBranchEdit, setIsBranchEdit] = useState(false);

  // Update handleItemClick to set selected branch for editing
  const handleItemClick = (supbranchcode, action) => {
    if (action === "Edit" && datasupbranch) {
      const branch = datasupbranch.find(
        (b) => b.supbranchcode === supbranchcode
      );
      if (branch) {
        setSelectedbranch({
          branchname: branch.branchname || "",
          addresslinE1: branch.addresslinE1 || "",
          addresslinE2: branch.addresslinE2 || "",
          addresslinE3: branch.addresslinE3 || "",
          country: branch.country || "",
          province: branch.province || "",
          city: branch.city || "",
          contactno: branch.contactno || "",
          descrip: branch.descrip || "",
          email: branch.email || "",
          supbranchcode: branch.supbranchcode, // include code for editing
        });
        setIsBranchEdit(true);
      }
    }
  };

  const menuItems = [
    {
      text: "Edit",
      icon: <BorderColorOutlinedIcon />,
      onClick: (supbranchcode) => handleItemClick(supbranchcode, "Edit"),
    },
  ];

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await externalgetApi(SUPPLIER_API_02, "get", {
          COMPCODE,
          LOCCODE: STAFFMAPLOCODE,
          STS: CON_STATUS_ACTIVE,
        });

        // Format all date fields in each row
        const formattedResult = Array.isArray(result)
          ? result.map(formatAllDates)
          : [];
        setData(formattedResult);
        console.log("result", formattedResult);
        setIsLoading(false);
      } catch (err) {
        setError(err);
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    fetchDatasupbranch();
  }, [selectedItemDetails.suprefcode]);

  const fetchDatasupbranch = async () => {
    try {
      const result = await externalgetApi(SUPPLIER_API_06, "get", {
        suprefcode: selectedItemDetails.suprefcode || 0,

        STS: CON_STATUS_ACTIVE,
      });

      setDatasupbranch(result);
      console.log("result", result);
      setIsLoading(false);
    } catch (err) {
      setError(err);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await externalgetApi(SETTING_API_04, "get", {
          COMPCODE,
          LOCCODE: STAFFMAPLOCODE,

          STS: CON_STATUS_ACTIVE,
        });

        setDataindustry(result);

        setIsLoading(false);
      } catch (err) {
        setError(err);
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await externalgetApi(SUPPLIER_API_05, "get", {
          STS: CON_STATUS_ACTIVE,
        });

        setDataidentity(result);
        console.log("result", result);
        setIsLoading(false);
      } catch (err) {
        setError(err);
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  // Add this computed variable in your component
  const industryOptions =
    dataindustry && Array.isArray(dataindustry)
      ? dataindustry.map((item) => ({
          label: String(item.industryname),
          value: String(item.industrycode),
        }))
      : [];

  // 2. Use in Autocomplete

  const handleConfirmClick = async () => {
    setIsButtonDisabled(true);
    const { firstname } = selectedItemDetails;

    const requiredFields =
      supplierType === "Cooperate"
        ? [
            {
              name: "companyname",
              value: selectedItemDetails.companyname,
              label: "Company Name",
            },
            {
              name: "industryname",
              value: selectedItemDetails.industryname,
              label: "Industry Type",
            },
            {
              name: "busregno",
              value: selectedItemDetails.busregno,
              label: "Business Registered Number",
            },
            { name: "email", value: selectedItemDetails.email, label: "Email" },
            {
              name: "contactno",
              value: selectedItemDetails.contactno,
              label: "Business Contact Number",
            },
            {
              name: "contactpersonceo",
              value: selectedItemDetails.contactpersonceo,
              label: "CEO Name",
            },
            {
              name: "emailceo",
              value: selectedItemDetails.emailceo,
              label: "CEO Email",
            },
            {
              name: "dateofbusreg",
              value: selectedItemDetails.dateofbusreg,
              label: "Date of Business Registration",
            },
            {
              name: "mobileceo",
              value: selectedItemDetails.mobileceo,
              label: "CEO Mobile Number",
            },
            {
              name: "country",
              value: selectedItemDetails.country,
              label: "Country",
            },
            { name: "city", value: selectedItemDetails.city, label: "City" },
            {
              name: "province",
              value: selectedItemDetails.province,
              label: "Province",
            },
            {
              name: "addresslinE1",
              value: selectedItemDetails.addresslinE1,
              label: "Address Line 1",
            },
            {
              name: "addresslinE2",
              value: selectedItemDetails.addresslinE2,
              label: "Address Line 2",
            },

            {
              name: "vatno",
              value: selectedItemDetails.vatno,
              label: "VAT Number",
            },
            {
              name: "isvat",
              value: selectedItemDetails.isvat,
              label: "VAT Registered",
            },
            {
              name: "emailpro",
              value: selectedItemDetails.emailpro,
              label: "Professional Email",
            },
            {
              name: "mobilepro",
              value: selectedItemDetails.mobilepro,
              label: "Professional Mobile Number",
            },
            {
              name: "emailpay",
              value: selectedItemDetails.emailpay,
              label: "Payment Email",
            },
            {
              name: "mobilepay",
              value: selectedItemDetails.mobilepay,
              label: "Payment Mobile Number",
            },
            {
              name: "contactpersonpay",
              value: selectedItemDetails.contactpersonpay,
              label: "Contact Person Name",
            },
            {
              name: "contactpersonpro",
              value: selectedItemDetails.contactpersonpro,
              label: "Contact Person Name",
            },
          ]
        : [
            {
              name: "suptitle",
              value: selectedItemDetails.suptitle,
              label: "Title",
            },
            {
              name: "initialname",
              value: selectedItemDetails.initialname,
              label: "Initial Name",
            },
            {
              name: "firstname",
              value: selectedItemDetails.firstname,
              label: "First Name",
            },
            {
              name: "lastname",
              value: selectedItemDetails.lastname,
              label: "Last Name",
            },
            { name: "email", value: selectedItemDetails.email, label: "Email" },
            {
              name: "contactno",
              value: selectedItemDetails.contactno,
              label: "Mobile Number",
            },
            {
              name: "identitytype",
              value: selectedItemDetails.identitytype,
              label: "Identification Type",
            },
            {
              name: "identityno",
              value: selectedItemDetails.identityno,
              label: "Identification Number",
            },
            {
              name: "industryname",
              value: selectedItemDetails.industryname,
              label: "Industry Type",
            },
            {
              name: "emailpro",
              value: selectedItemDetails.emailpro,
              label: "Professional Email",
            },
            {
              name: "mobilepro",
              value: selectedItemDetails.mobilepro,
              label: "Professional Mobile Number",
            },
            {
              name: "emailpay",
              value: selectedItemDetails.emailpay,
              label: "Payment Email",
            },
            {
              name: "mobilepay",
              value: selectedItemDetails.mobilepay,
              label: "Payment Mobile Number",
            },
            {
              name: "contactpersonpay",
              value: selectedItemDetails.contactpersonpay,
              label: "Contact Person Name",
            },
            {
              name: "contactpersonpro",
              value: selectedItemDetails.contactpersonpro,
              label: "Contact Person Name",
            },
          ];

    const emailFields = ["email", "emailpay", "emailpro", "emailceo"];
    for (const field of emailFields) {
      if (error[field]) {
        setAlertType("error");
        setAlertMessage("Please correct the email fields before submitting.");
        setAlertOpen(true);
        setIsButtonDisabled(false);
        return;
      }
    }

    // Add this for mobile fields
    const mobileFields = [
      "mobileno",
      "contactno",
      "mobileceo",
      "mobilepro",
      "mobilepay",
    ];
    for (const field of mobileFields) {
      if (error[field]) {
        setAlertType("error");
        setAlertMessage(
          "Please correct the mobile number fields before submitting."
        );
        setAlertOpen(true);
        setIsButtonDisabled(false);
        return;
      }
    }

    const missingRequiredFields = requiredFields.filter((field) => {
      if (field.name === "vatno" && selectedItemDetails.isvat !== "Y") {
        return false;
      }
      return !field.value;
    });
    if (missingRequiredFields.length > 0) {
      const newError = {};
      missingRequiredFields.forEach((field) => {
        newError[field.name] = `${field.label} is required.`;
      });
      setError(newError);

      //  const errorMessage = `Required fields: ${missingFieldLabels}.`;
      setAlertType("error");
      setAlertMessage("Please Fill All the Required Fields.");
      setAlertOpen(true); // Open the alert
      setIsButtonDisabled(false);
      return;
    }

    if (data) {
      const isDuplicate = data.some((item) => {
        if (item.suprefcode !== selectedItemDetails.suprefcode) {
          if (supplierType === "Cooperate") {
            const itemCompany = item.companyname
              ? item.companyname.toLowerCase()
              : "";
            const selectedCompany = selectedItemDetails.companyname
              ? selectedItemDetails.companyname.toLowerCase()
              : "";
            return itemCompany === selectedCompany;
          } else {
            const itemFirst = item.firstname
              ? item.firstname.toLowerCase()
              : "";
            const selectedFirst = selectedItemDetails.firstname
              ? selectedItemDetails.firstname.toLowerCase()
              : "";
            return itemFirst === selectedFirst;
          }
        }
        return false;
      });

      if (isDuplicate) {
        setAlertMessage(
          supplierType === "Cooperate"
            ? "Company Name Already Exists."
            : "Supplier Name Already Exists."
        );
        setAlertType("warning");
        setAlertOpen(true); // Open the alert
        setIsButtonDisabled(false);
        return;
      }
    }

    const BRAND_CODE = selectedItem ? selectedItem.suprefcode : 0;
    console.log("Brand Code:", BRAND_CODE);

    const staticValues = {
      COMPCODE,
      // LOCCODE: STAFFMAPLOCODE,

      STS: CON_STATUS_ACTIVE,
      ENUSER: USERNAME,
    };

    const payload = {
      ...selectedItemDetails,
      ...staticValues,
      suprefcode: String(BRAND_CODE),
      suptypecode: supplierType === "Cooperate" ? "2" : "1",
      endate: dayjs().format("YYYY-MM-DD"), // set to today's date in ISO format
    };

    try {
      console.log("Payload for API call:", payload);
      const responseData = await externalpostApi(SUPPLIER_API_01, payload);
      console.log("Success:", responseData);
      setAlertMessage(
        `${isEdit ? "Updated Successfully!" : "Created Successfully!"}`
      );
      setAlertType("success");

      setAlertOpen(true);
      if (responseData && responseData.suprefcode) {
        setSuprefcode(responseData.suprefcode); // <-- update parent state
        console.log("Suprefcode set in parent:", responseData.suprefcode);
      }
      // handleSupplierClear();
    } catch (error) {
      console.error("Error:", error);
      setAlertType("error");
      setAlertMessage("An unexpected error occurred.");
      setAlertOpen(true); // Open the alert
    }
  };

  const handleBranchConfirmClick = async () => {
    setIsButtonDisabled(true);
    const { branchname } = selectedbranch;
    const emailFields = ["email"];
    for (const field of emailFields) {
      if (errorsup[field]) {
        setAlertType("error");
        setAlertMessage("Please correct the email fields before submitting.");
        setAlertOpen(true);
        setIsButtonDisabled(false);
        return;
      }
    }

    // Add this for mobile fields
    const mobileFields = ["contactno"];
    for (const field of mobileFields) {
      if (errorsup[field]) {
        setAlertType("error");
        setAlertMessage(
          "Please correct the mobile number fields before submitting."
        );
        setAlertOpen(true);
        setIsButtonDisabled(false);
        return;
      }
    }
    const requiredFields = [
      {
        name: "branchname",
        value: selectedbranch.branchname,
        label: "Branch Name",
      },
      {
        name: "contactno",
        value: selectedbranch.contactno,
        label: "Contact Number",
      },
      { name: "email", value: selectedbranch.email, label: "Email" },
      { name: "country", value: selectedbranch.country, label: "Country" },
      { name: "city", value: selectedbranch.city, label: "City" },
      { name: "province", value: selectedbranch.province, label: "Province" },
      {
        name: "addresslinE1",
        value: selectedbranch.addresslinE1,
        label: "Address Line 1",
      },
      {
        name: "addresslinE2",
        value: selectedbranch.addresslinE2,
        label: "Address Line 2",
      },
      // Add more fields as needed
    ];
    const missingRequiredFields = requiredFields.filter(
      (field) => !field.value
    );
    if (missingRequiredFields.length > 0) {
      const newError = {};
      missingRequiredFields.forEach((field) => {
        newError[field.name] = `${field.label} is required.`;
      });
      setErrorsup(newError);

      //  const errorMessage = `Required fields: ${missingFieldLabels}.`;
      setAlertType("error");
      setAlertMessage("Please Fill All the Required Fields.");
      setAlertOpen(true); // Open the alert
      setIsButtonDisabled(false);
      return;
    }

    if (datasupbranch) {
      const isDuplicate = datasupbranch.some((item) => {
        if (
          item.supbranchcode !== selectedbranch.supbranchcode &&
          item.branchname.toLowerCase() === branchname.toLowerCase()
        ) {
          return true;
        } else {
          return false;
        }
      });

      if (isDuplicate) {
        setAlertMessage("Branch Name Already Exists.");
        setAlertType("warning");

        setAlertOpen(true); // Open the alert
        return;
      }
    }

    const BRAND_CODE = selectedItem ? selectedbranch.supbranchcode : 0;
    console.log("Brand Code:", BRAND_CODE);

    const staticValues = {
      STS: CON_STATUS_ACTIVE,
      ENUSER: USERNAME,
      ENDATE: dayjs().format("YYYY-MM-DD"),
    };

    const payload = {
      ...selectedbranch,
      ...staticValues,
      suprefcode: selectedItemDetails.suprefcode || 0,
      supbranchcode: BRAND_CODE,
    };

    try {
      console.log("Payload for API call:", payload);
      const responseData = await externalpostApi(SUPPLIER_API_06, payload);
      console.log("Success:", responseData);
      setAlertMessage(
        `${isEdit ? "Updated Successfully!" : "Created Successfully!"}`
      );
      setAlertType("success");

      setAlertOpen(true);
      fetchDatasupbranch();
      setSelectedbranch({
        branchname: "",
        addresslinE1: "",
        addresslinE2: "",
        addresslinE3: "",
        country: "",
        province: "",
        city: "",
        contactno: "",
        descrip: "",
        email: "",
      });
    } catch (error) {
      console.error("Error:", error);
      setAlertType("error");
      setAlertMessage("An unexpected error occurred.");
      setAlertOpen(true); // Open the alert
    }
  };

  const handleBranchClear = () => {
    setSelectedbranch({
      branchname: "",
      addresslinE1: "",
      addresslinE2: "",
      addresslinE3: "",
      country: "",
      province: "",
      city: "",
      contactno: "",
      descrip: "",
      email: "",
    });
  };

  const handleSupplierClear = () => {
    setSelectedItemDetails({
      suprefcode: "",
      suptitle: "",
      firstname: "",
      lastname: "",
      initialname: "",
      middlename: "",
      email: "",
      mobileno: "",
      identityno: "",
      identitytype: "",
      expdate: "",
      addresslinE1: "",
      addresslinE2: "",
      addresslinE3: "",
      city: "",
      country: "",
      isvat: "",
      tino: "",
      vatno: "",
      contactno: "",
      contactperson: "",
      province: "",
      suptypecode: "",
      faxno: "",
      descrip: "",
      companyname: "",
      industryname: "",
      industrycode: "",
      busregno: "",
      dateofbusreg: "",
      identitycode: "",
      contactpersonceo: "",
      emailceo: "",
      mobileceo: "",
      contactpersonpro: "",
      emailpro: "",
      mobilepro: "",
      contactpersonpay: "",
      emailpay: "",
      mobilepay: "",
      copdate: dayjs().format("YYYY-MM-DD"),
    });
  };
  return (
    <>
      <Box
        component="form"
        noValidate
        autoComplete="off"
        sx={{ ...styles.add_form_page_container, mb: 2 }}
      >
        <Grid container spacing={2} mb={2}>
          <Grid item size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}>
            <Typography sx={styles.supplier_sub_title_text}>
              Supplier Details
            </Typography>
          </Grid>

          <Grid
            item
            size={{ xs: 12, sm: 12, md: 10, lg: 10, xl: 10 }}
            container
            spacing={2}
          >
            <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
              <TextField
                id="sup-code"
                label="Supplier Code"
                variant="outlined"
                name="suprefcode"
                value={selectedItemDetails.suprefcode}
                fullWidth
                disabled
                size="small"
                FormHelperTextProps={{
                  sx: { fontSize: "12px", color: "red" }, // Customize font size and color
                }}
              />
            </Grid>
            {supplierType === "Cooperate" ? (
              <>
                <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
                  <TextField
                    id="cmp-name"
                    label="Company Name"
                    variant="outlined"
                    fullWidth
                    size="small"
                    required
                    name="companyname"
                    value={selectedItemDetails.companyname}
                    onChange={handleInputChange}
                    error={!!error.companyname}
                    helperText={error.companyname}
                    FormHelperTextProps={{
                      sx: { fontSize: "12px", color: "red" }, // Customize font size and color
                    }}
                  />
                </Grid>
                {/* <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
                  <Autocomplete
                    options={industryOptions}
                    getOptionLabel={(option) => option.label || ""}
                    value={
                      industryOptions.find(
                        (opt) => opt.label === selectedItemDetails.industryname
                      ) || null
                    }
                    onChange={(_, newValue) => {
                      handleInputChange({
                        target: {
                          name: "industrycode",
                          value: newValue ? newValue.value : "",
                        },
                      });
                      handleInputChange({
                        target: {
                          name: "industryname",
                          value: newValue ? newValue.label : "",
                        },
                      });
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Industry Type"
                        variant="outlined"
                        size="small"
                        fullWidth
                        error={!!error.industrytype}
                        helperText={error.industrytype}
                      />
                    )}
                    fullWidth
                    size="small"
                  />
                </Grid>  */}

                <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
                  <TextField
                    id="ceo-email"
                    label="Business Registered Number"
                    variant="outlined"
                    fullWidth
                    size="small"
                    required
                    name="busregno"
                    value={selectedItemDetails.busregno}
                    onChange={handleInputChange}
                    error={!!error.busregno}
                    helperText={error.busregno}
                    FormHelperTextProps={{
                      sx: { fontSize: "12px", color: "red" }, // Customize font size and color
                    }}
                  />
                </Grid>

                {/* <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
                  <Box sx={styles.box_ipt_file}>
                    <Button
                      variant="contained"
                      color="primary"
                      startIcon={<AttachFileIcon />}
                      component="label"
                      sx={{
                        ...styles.btn_primary,
                      }}
                    >
                      Attach
                      <input type="file" hidden onChange={handleFileChange} />
                    </Button>
                    <TextField
                      variant="outlined"
                      disabled
                      fullWidth
                      value={fileName}
                      size="small"
                      sx={styles.ipt_file_attach}
                    />
                  </Box>
                </Grid> */}
                <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      id="dateofbusreg"
                      label="Date of In Cooperate"
                      value={
                        selectedItemDetails.dateofbusreg
                          ? dayjs(selectedItemDetails.dateofbusreg)
                          : null
                      }
                      onChange={(newValue) => {
                        handleInputChange({
                          target: {
                            name: "dateofbusreg",
                            value: newValue
                              ? dayjs(newValue).format("YYYY-MM-DD")
                              : "",
                          },
                        });
                      }}
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          size: "small",
                          required: supplierType === "Cooperate",
                          error: !!error.dateofbusreg,
                          helperText: error.dateofbusreg,
                          FormHelperTextProps: {
                            sx: { fontSize: "12px", color: "red" },
                          },
                        },
                      }}
                    />
                  </LocalizationProvider>
                </Grid>
                <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
                  <TextField
                    label="Email"
                    variant="outlined"
                    fullWidth
                    size="small"
                    required
                    name="email"
                    value={selectedItemDetails.email}
                    onChange={handleInputChange}
                    error={!!error.email}
                    helperText={error.email}
                    FormHelperTextProps={{
                      sx: { fontSize: "12px", color: "red" }, // Customize font size and color
                    }}
                  />
                </Grid>
                <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
                  <TextField
                    label="Business Contact Number"
                    variant="outlined"
                    fullWidth
                    size="small"
                    required
                    name="contactno"
                    value={selectedItemDetails.contactno}
                    onChange={handleInputChange}
                    error={!!error.contactno}
                    helperText={error.contactno}
                    FormHelperTextProps={{
                      sx: { fontSize: "12px", color: "red" }, // Customize font size and color
                    }}
                  />
                </Grid>
              </>
            ) : (
              <>
                <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
                  <Autocomplete
                    options={titleOptions}
                    getOptionLabel={(option) => option.label}
                    disableClearable
                    value={
                      titleOptions.find(
                        (opt) => opt.value === selectedItemDetails.suptitle
                      ) || null
                    }
                    onChange={(_, newValue) => {
                      handleInputChange({
                        target: {
                          name: "suptitle",
                          value: newValue ? newValue.value : "",
                        },
                      });
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Title"
                        variant="outlined"
                        size="small"
                        fullWidth
                        required
                        error={!!error.suptitle}
                        helperText={error.suptitle}
                        FormHelperTextProps={{
                          sx: { fontSize: "12px", color: "red" }, // Customize font size and color
                        }}
                      />
                    )}
                    fullWidth
                    size="small"
                  />
                </Grid>
                <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
                  <TextField
                    id="Initial-name"
                    label="Initial Name"
                    variant="outlined"
                    fullWidth
                    size="small"
                    required
                    name="initialname"
                    value={selectedItemDetails.initialname}
                    onChange={handleInputChange}
                    error={!!error.initialname}
                    helperText={error.initialname}
                    FormHelperTextProps={{
                      sx: { fontSize: "12px", color: "red" }, // Customize font size and color
                    }}
                  />
                </Grid>
                <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
                  <TextField
                    id="first-name"
                    label="First Name"
                    variant="outlined"
                    fullWidth
                    size="small"
                    required
                    name="firstname"
                    value={selectedItemDetails.firstname}
                    onChange={handleInputChange}
                    error={!!error.firstname}
                    helperText={error.firstname}
                    FormHelperTextProps={{
                      sx: { fontSize: "12px", color: "red" }, // Customize font size and color
                    }}
                  />
                </Grid>

                <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
                  <TextField
                    id="Initial-name"
                    label="Middle Name"
                    variant="outlined"
                    fullWidth
                    size="small"
                    // required
                    name="middlename"
                    value={selectedItemDetails.middlename}
                    onChange={handleInputChange}
                    error={!!error.middlename}
                    helperText={error.middlename}
                    FormHelperTextProps={{
                      sx: { fontSize: "12px", color: "red" }, // Customize font size and color
                    }}
                  />
                </Grid>
                <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
                  <TextField
                    id="last-name"
                    label="Last Name"
                    variant="outlined"
                    fullWidth
                    size="small"
                    required
                    name="lastname"
                    value={selectedItemDetails.lastname}
                    onChange={handleInputChange}
                    error={!!error.lastname}
                    helperText={error.lastname}
                    FormHelperTextProps={{
                      sx: { fontSize: "12px", color: "red" }, // Customize font size and color
                    }}
                  />
                </Grid>
                <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
                  <TextField
                    label="Email"
                    variant="outlined"
                    fullWidth
                    size="small"
                    required
                    name="email"
                    value={selectedItemDetails.email}
                    onChange={handleInputChange}
                    error={!!error.email}
                    helperText={error.email}
                    FormHelperTextProps={{
                      sx: { fontSize: "12px", color: "red" }, // Customize font size and color
                    }}
                  />
                </Grid>
                <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
                  <TextField
                    label="Mobile Number"
                    variant="outlined"
                    fullWidth
                    size="small"
                    required
                    name="contactno"
                    value={selectedItemDetails.contactno}
                    onChange={handleInputChange}
                    error={!!error.contactno}
                    helperText={error.contactno}
                    FormHelperTextProps={{
                      sx: { fontSize: "12px", color: "red" }, // Customize font size and color
                    }}
                  />
                </Grid>
              </>
            )}
          </Grid>
        </Grid>
        <Divider />

        {/*  */}
        {supplierType === "Individual" && (
          <>
            <Grid container spacing={2} mt={4} mb={2}>
              <Grid item size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}>
                <Typography sx={styles.supplier_sub_title_text}>
                  Identification Details
                </Typography>
              </Grid>

              <Grid
                item
                size={{ xs: 12, sm: 12, md: 10, lg: 10, xl: 10 }}
                container
                spacing={2}
              >
                <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
                  <Autocomplete
                    options={identityTypeOptions}
                    getOptionLabel={(option) => option.label || ""}
                    disableClearable
                    value={
                      identityTypeOptions.find(
                        (opt) =>
                          opt.value === String(selectedItemDetails.identitycode)
                      ) || null
                    }
                    onChange={(_, newValue) => {
                      handleInputChange({
                        target: {
                          name: "identitytype",
                          value: newValue ? newValue.label : "",
                        },
                      });
                      handleInputChange({
                        target: {
                          name: "identitycode",
                          value: newValue ? newValue.value : "",
                        },
                      });
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Identification Type"
                        variant="outlined"
                        size="small"
                        fullWidth
                        required
                        error={!!error.identitytype}
                        helperText={error.identitytype}
                        FormHelperTextProps={{
                          sx: { fontSize: "12px", color: "red" },
                        }}
                      />
                    )}
                    fullWidth
                    size="small"
                  />
                </Grid>
                <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
                  <TextField
                    id="last-name"
                    label="Identification Number"
                    variant="outlined"
                    fullWidth
                    size="small"
                    required
                    name="identityno"
                    value={selectedItemDetails.identityno}
                    onChange={handleInputChange}
                    error={!!error.identityno}
                    helperText={error.identityno}
                    FormHelperTextProps={{
                      sx: { fontSize: "12px", color: "red" }, // Customize font size and color
                    }}
                  />
                </Grid>

                {/* <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      id="exp date"
                      label="Expiry Date"
                      value={
                        selectedItemDetails.expdate
                          ? dayjs(selectedItemDetails.expdate)
                          : null
                      }
                      onChange={(newValue) => {
                        handleInputChange({
                          target: {
                            name: "expdate",
                            value: newValue
                              ? dayjs(newValue).format("YYYY-MM-DD")
                              : "",
                          },
                        });
                      }}
                      slotProps={{
                        textField: { fullWidth: true, size: "small" },
                      }}
                    />
                  </LocalizationProvider>
                </Grid> */}
                {/* <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
                  <Box sx={styles.box_ipt_file}>
                    <Button
                      variant="contained"
                      color="primary"
                      startIcon={<AttachFileIcon />}
                      component="label"
                      sx={{
                        ...styles.btn_primary,
                      }}
                    >
                      Attach
                      <input type="file" hidden onChange={handleFileChange} />
                    </Button>
                    <TextField
                      variant="outlined"
                      disabled
                      fullWidth
                      value={fileName}
                      size="small"
                      sx={styles.ipt_file_attach}
                    />
                  </Box>
                </Grid> */}
              </Grid>
            </Grid>
          </>
        )}

        <Divider />

        {/*  */}
        <Grid container spacing={2} mt={4} mb={2}>
          <Grid
            item
            size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}
            // sx={{ display: "flex", alignItems: "center", gap: 2 }}
          >
            <Typography sx={styles.supplier_sub_title_text}>
              {supplierType === "Cooperate"
                ? "     Cooperation Address"
                : "Address "}
            </Typography>
          </Grid>
          <Grid
            container
            spacing={2}
            size={{ xs: 12, sm: 12, md: 10, lg: 10, xl: 10 }}
          >
            <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
              <Autocomplete
                disableClearable
                options={countryOptions}
                getOptionLabel={(option) => option.label || ""}
                value={
                  countryOptions.find(
                    (opt) => opt.label === selectedItemDetails.country
                  ) || null
                }
                onChange={(_, newValue) => {
                  handleInputChange({
                    target: {
                      name: "country",
                      value: newValue ? newValue.label : "",
                    },
                  });
                  handleInputChange({
                    target: {
                      name: "countrycode",
                      value: newValue ? newValue.value : "",
                    },
                  });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Country"
                    variant="outlined"
                    size="small"
                    name="country"
                    required={supplierType === "Cooperate"}
                    error={!!error.country}
                    helperText={error.country}
                    FormHelperTextProps={{
                      sx: { fontSize: "12px", color: "red" },
                    }}
                  />
                )}
                fullWidth
                size="small"
              />
            </Grid>
            <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
              <TextField
                id="city"
                label="City"
                variant="outlined"
                fullWidth
                size="small"
                name="city"
                value={selectedItemDetails.city}
                onChange={handleInputChange}
                required={supplierType === "Cooperate"}
                error={!!error.city}
                helperText={error.city}
                FormHelperTextProps={{
                  sx: { fontSize: "12px", color: "red" }, // Customize font size and color
                }}
              />
            </Grid>
            <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
              <TextField
                id="city"
                label="Province"
                variant="outlined"
                fullWidth
                size="small"
                name="province"
                required={supplierType === "Cooperate"}
                value={selectedItemDetails.province}
                onChange={handleInputChange}
                error={!!error.province}
                helperText={error.province}
                FormHelperTextProps={{
                  sx: { fontSize: "12px", color: "red" }, // Customize font size and color
                }}
              />
            </Grid>
            <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
              <TextField
                id="address1"
                label="Address Line 1"
                variant="outlined"
                fullWidth
                size="small"
                name="addresslinE1"
                value={selectedItemDetails.addresslinE1}
                required={supplierType === "Cooperate"}
                onChange={handleInputChange}
                error={!!error.addresslinE1}
                helperText={error.addresslinE1}
                FormHelperTextProps={{
                  sx: { fontSize: "12px", color: "red" }, // Customize font size and color
                }}
              />
            </Grid>
            <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
              <TextField
                id="address1"
                label="Address Line 2"
                variant="outlined"
                fullWidth
                size="small"
                name="addresslinE2"
                required={supplierType === "Cooperate"}
                value={selectedItemDetails.addresslinE2}
                onChange={handleInputChange}
                error={!!error.addresslinE2}
                helperText={error.addresslinE2}
                FormHelperTextProps={{
                  sx: { fontSize: "12px", color: "red" }, // Customize font size and color
                }}
              />
            </Grid>
            <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
              <TextField
                id="address1"
                label="Address Line 3"
                variant="outlined"
                fullWidth
                size="small"
                name="addresslinE3"
                value={selectedItemDetails.addresslinE3}
                onChange={handleInputChange}
                error={!!error.addresslinE3}
                helperText={error.addresslinE3}
                FormHelperTextProps={{
                  sx: { fontSize: "12px", color: "red" }, // Customize font size and color
                }}
              />
            </Grid>
          </Grid>
        </Grid>
        <Divider />

        <Grid container spacing={2} mt={4} mb={2}>
          <Grid
            item
            size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}
            // sx={{ display: "flex", alignItems: "center", gap: 2 }}
          >
            <Typography sx={styles.supplier_sub_title_text}>
              Legal Details
            </Typography>
          </Grid>
          <Grid
            container
            spacing={2}
            size={{ xs: 12, sm: 12, md: 10, lg: 10, xl: 10 }}
          >
            <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
              <Autocomplete
                options={industryOptions}
                getOptionLabel={(option) => option.label || ""}
                disableClearable
                value={
                  industryOptions.find(
                    (opt) => opt.label === selectedItemDetails.industryname
                  ) || null
                }
                onChange={(_, newValue) => {
                  handleInputChange({
                    target: {
                      name: "industrycode",
                      value: newValue ? newValue.value : "",
                    },
                  });
                  handleInputChange({
                    target: {
                      name: "industryname",
                      value: newValue ? newValue.label : "",
                    },
                  });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Industry Type"
                    variant="outlined"
                    size="small"
                    required
                    fullWidth
                    error={!!error.industryname}
                    helperText={error.industryname}
                    FormHelperTextProps={{
                      sx: { fontSize: "12px", color: "red" }, // Customize font size and color
                    }}
                  />
                )}
                fullWidth
                size="small"
              />
            </Grid>

            <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
              <TextField
                id="Tax Identification Number"
                label="Tax Identification Number"
                variant="outlined"
                fullWidth
                size="small"
                name="tino"
                value={selectedItemDetails.tino}
                onChange={handleInputChange}
                error={!!error.tino}
                helperText={error.tino}
                FormHelperTextProps={{
                  sx: { fontSize: "12px", color: "red" }, // Customize font size and color
                }}
              />
            </Grid>
            <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
              <FormControl
                variant="outlined"
                fullWidth
                size="small"
                error={!!error.isvat}
              >
                <InputLabel required={supplierType === "Cooperate"}>
                  VAT Registered
                </InputLabel>
                <Select
                  label="VAT Registered"
                  name="isvat"
                  value={selectedItemDetails.isvat}
                  onChange={handleInputChange}
                  required={supplierType === "Cooperate"}
                >
                  <MenuItem value="Y">Yes</MenuItem>
                  <MenuItem value="N">No</MenuItem>
                </Select>
                {error.isvat && (
                  <Typography
                    variant="caption"
                    color="error"
                    sx={{ fontSize: "12px" }}
                  >
                    {error.isvat}
                  </Typography>
                )}
              </FormControl>
            </Grid>
            <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
              <TextField
                id="VAT Number"
                label="VAT Number"
                variant="outlined"
                fullWidth
                size="small"
                name="vatno"
                value={selectedItemDetails.vatno}
                onChange={handleInputChange}
                required={
                  supplierType === "Cooperate" &&
                  selectedItemDetails.isvat === "Y"
                }
                disabled={selectedItemDetails.isvat !== "Y"}
                error={selectedItemDetails.isvat === "Y" && !!error.vatno}
                helperText={
                  selectedItemDetails.isvat === "Y" ? error.vatno : ""
                }
                FormHelperTextProps={{
                  sx: { fontSize: "12px", color: "red" },
                }}
              />
            </Grid>
            {/* <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
              <Box sx={styles.box_ipt_file}>
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<AttachFileIcon />}
                  component="label"
                  sx={{
                    ...styles.btn_primary,
                  }}
                >
                  Attach
                  <input type="file" hidden onChange={handleFileChange} />
                </Button>
                <TextField
                  variant="outlined"
                  disabled
                  fullWidth
                  value={fileName}
                  size="small"
                  sx={styles.ipt_file_attach}
                />
              </Box>
            </Grid> */}
          </Grid>
        </Grid>
        <Divider />

        <Grid container spacing={2} mt={4} mb={2}>
          <Grid
            item
            size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}
            // sx={{ display: "flex", alignItems: "center", gap: 2 }}
          >
            <Typography sx={styles.supplier_sub_title_text}>
              Contact Information
            </Typography>
          </Grid>
          <Grid
            container
            item
            size={{ xs: 12, sm: 12, md: 10, lg: 10, xl: 10 }}
          >
            {supplierType === "Cooperate" && (
              <>
                <Grid
                  container
                  spacing={2}
                  size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}
                >
                  <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                    <Typography sx={styles.supplier_sub_title_text}>
                      CEO Details
                    </Typography>
                  </Grid>
                  <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                    <TextField
                      id="first-name"
                      label="Name"
                      variant="outlined"
                      fullWidth
                      size="small"
                      required
                      name="contactpersonceo"
                      value={selectedItemDetails.contactpersonceo}
                      onChange={handleInputChange}
                      error={!!error.contactpersonceo}
                      helperText={error.contactpersonceo}
                      FormHelperTextProps={{
                        sx: { fontSize: "12px", color: "red" }, // Customize font size and color
                      }}
                    />
                  </Grid>

                  <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                    <TextField
                      id="ceo-email"
                      label="Email"
                      variant="outlined"
                      fullWidth
                      size="small"
                      required
                      name="emailceo"
                      value={selectedItemDetails.emailceo}
                      onChange={handleInputChange}
                      error={!!error.emailceo}
                      helperText={error.emailceo}
                      FormHelperTextProps={{
                        sx: { fontSize: "12px", color: "red" }, // Customize font size and color
                      }}
                    />
                  </Grid>
                  <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                    <TextField
                      id="ceo-mnmb"
                      label="Mobile Number"
                      variant="outlined"
                      fullWidth
                      size="small"
                      required
                      name="mobileceo"
                      value={selectedItemDetails.mobileceo}
                      onChange={handleInputChange}
                      error={!!error.mobileceo}
                      helperText={error.mobileceo}
                      FormHelperTextProps={{
                        sx: { fontSize: "12px", color: "red" }, // Customize font size and color
                      }}
                    />
                  </Grid>
                </Grid>
              </>
            )}
            <Grid
              container
              spacing={2}
              size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}
            >
              <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                <Typography sx={styles.supplier_sub_title_text}>
                  Vendor Contact for Procurement Purpose
                </Typography>
              </Grid>

              <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                <TextField
                  id="cpname"
                  label="Contact Person Name"
                  variant="outlined"
                  fullWidth
                  size="small"
                  name="contactpersonpro"
                  required
                  value={selectedItemDetails.contactpersonpro}
                  onChange={handleInputChange}
                  error={!!error.contactpersonpro}
                  helperText={error.contactpersonpro}
                  FormHelperTextProps={{
                    sx: { fontSize: "12px", color: "red" }, // Customize font size and color
                  }}
                />
              </Grid>
              <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                <TextField
                  id="email"
                  label="Email"
                  variant="outlined"
                  fullWidth
                  size="small"
                  name="emailpro"
                  required
                  value={selectedItemDetails.emailpro}
                  onChange={handleInputChange}
                  error={!!error.emailpro}
                  helperText={error.emailpro}
                  FormHelperTextProps={{
                    sx: { fontSize: "12px", color: "red" }, // Customize font size and color
                  }}
                />
              </Grid>

              <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                <TextField
                  id="mnmb"
                  label="Mobile Number"
                  variant="outlined"
                  fullWidth
                  size="small"
                  name="mobilepro"
                  required
                  value={selectedItemDetails.mobilepro}
                  onChange={handleInputChange}
                  error={!!error.mobilepro}
                  helperText={error.mobilepro}
                  FormHelperTextProps={{
                    sx: { fontSize: "12px", color: "red" }, // Customize font size and color
                  }}
                />
              </Grid>
            </Grid>
            <Grid
              container
              spacing={2}
              size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}
            >
              <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                <Typography sx={styles.supplier_sub_title_text}>
                  Vendor Contact for Payment Purpose
                </Typography>
              </Grid>

              <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                <TextField
                  id="cpname"
                  label="Contact Person Name"
                  variant="outlined"
                  fullWidth
                  size="small"
                  name="contactpersonpay"
                  value={selectedItemDetails.contactpersonpay}
                  onChange={handleInputChange}
                  required
                  error={!!error.contactpersonpay}
                  helperText={error.contactpersonpay}
                  FormHelperTextProps={{
                    sx: { fontSize: "12px", color: "red" }, // Customize font size and color
                  }}
                />
              </Grid>
              <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                <TextField
                  id="email"
                  label="Email"
                  variant="outlined"
                  fullWidth
                  size="small"
                  name="emailpay"
                  required
                  value={selectedItemDetails.emailpay}
                  onChange={handleInputChange}
                  error={!!error.emailpay}
                  helperText={error.emailpay}
                  FormHelperTextProps={{
                    sx: { fontSize: "12px", color: "red" }, // Customize font size and color
                  }}
                />
              </Grid>

              <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                <TextField
                  id="mnmb"
                  label="Mobile Number"
                  variant="outlined"
                  fullWidth
                  size="small"
                  name="mobilepay"
                  value={selectedItemDetails.mobilepay}
                  onChange={handleInputChange}
                  required
                  error={!!error.mobilepay}
                  helperText={error.mobilepay}
                  FormHelperTextProps={{
                    sx: { fontSize: "12px", color: "red" }, // Customize font size and color
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
      <Box sx={styles.supplier_page_button_box}>
        <Button
          variant="outlined"
          size="medium"
          sx={{ ...styles.btn_secondary, ...styles.btn_add_cancel }}
          onClick={handleSupplierClear}
        >
          Clear
        </Button>
        <Button
          variant="contained"
          size="medium"
          sx={{ ...styles.btn_primary, ...styles.btn_add_confirm }}
          onClick={handleConfirmClick}
          disabled={isButtonDisabled}
        >
          {actionText === "Edit" ? " Modify" : "Save"}
        </Button>
        <SystemAlert
          open={alertOpen}
          type={alertType}
          message={alertMessage}
          onClose={() => setAlertOpen(false)}
        />
      </Box>

      {supplierType === "Cooperate" && (
        <>
          <Divider sx={{ mb: 2, mt: 4 }} />
          <Box
            component="form"
            noValidate
            autoComplete="off"
            sx={{ ...styles.add_form_page_container, mb: 2, mt: 4 }}
          >
            <Grid
              item
              size={{ xs: 12 }}
              sx={styles.appbar_grid_container_col_1}
            >
              <Typography sx={styles.appbar_title}>
                {" "}
                <Typography sx={styles.appbar_title}>
                  {actionText === "Edit"
                    ? "Edit Supplier Branch"
                    : "Create Supplier Branch"}
                </Typography>
              </Typography>
            </Grid>
            <Divider sx={{ mb: 2, mt: 2 }} />

            <Grid container spacing={2} mt={2}>
              <Grid
                item
                size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}
                // sx={{ display: "flex", alignItems: "center", gap: 2 }}
              >
                <Typography sx={styles.supplier_sub_title_text}>
                  Add Supplier Branch
                </Typography>
              </Grid>
              <Grid
                container
                spacing={2}
                size={{ xs: 12, sm: 12, md: 10, lg: 10, xl: 10 }}
              >
                <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                  <TextField
                    label="Branch Name"
                    variant="outlined"
                    fullWidth
                    size="small"
                    required
                    disabled={suprefcode === 0}
                    name="branchname"
                    value={selectedbranch.branchname}
                    onChange={handleBranchInputChange}
                    error={!!errorsup.branchname}
                    helperText={errorsup.branchname}
                    FormHelperTextProps={{
                      sx: { fontSize: "12px", color: "red" },
                    }}
                  />
                </Grid>
                <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                  <Autocomplete
                    options={countryOptions}
                    disableClearable
                    getOptionLabel={(option) => option.label}
                    value={
                      countryOptions.find(
                        (opt) => opt.label === selectedbranch.country
                      ) || null
                    }
                    onChange={(_, newValue) => {
                      handleBranchInputChange({
                        target: {
                          name: "country",
                          value: newValue ? newValue.label : "",
                        },
                      });
                      setSelectedbranch((prev) => ({
                        ...prev,
                        countrycode: newValue ? newValue.value : "",
                      }));
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Country"
                        variant="outlined"
                        size="small"
                        required
                        fullWidth
                        disabled={suprefcode === 0}
                        error={!!errorsup.country}
                        helperText={errorsup.country}
                        FormHelperTextProps={{
                          sx: { fontSize: "12px", color: "red" }, // Customize font size and color
                        }}
                      />
                    )}
                    fullWidth
                    size="small"
                  />
                </Grid>
                <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                  <TextField
                    id="city"
                    label="Province"
                    variant="outlined"
                    fullWidth
                    disabled={suprefcode === 0}
                    size="small"
                    name="province"
                    required
                    value={selectedbranch.province}
                    onChange={handleBranchInputChange}
                    error={!!errorsup.province}
                    helperText={errorsup.province}
                    FormHelperTextProps={{
                      sx: { fontSize: "12px", color: "red" }, // Customize font size and color
                    }}
                  />
                </Grid>

                <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                  <TextField
                    id="city"
                    label="City"
                    variant="outlined"
                    fullWidth
                    size="small"
                    name="city"
                    disabled={suprefcode === 0}
                    required
                    value={selectedbranch.city}
                    onChange={handleBranchInputChange}
                    error={!!errorsup.city}
                    helperText={errorsup.city}
                    FormHelperTextProps={{
                      sx: { fontSize: "12px", color: "red" }, // Customize font size and color
                    }}
                  />
                </Grid>
                <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                  <TextField
                    id="address1"
                    label="Address Line 1"
                    variant="outlined"
                    fullWidth
                    size="small"
                    name="addresslinE1"
                    required
                    disabled={suprefcode === 0}
                    value={selectedbranch.addresslinE1}
                    onChange={handleBranchInputChange}
                    error={!!errorsup.addresslinE1}
                    helperText={errorsup.addresslinE1}
                    FormHelperTextProps={{
                      sx: { fontSize: "12px", color: "red" }, // Customize font size and color
                    }}
                  />
                </Grid>
                <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                  <TextField
                    id="address1"
                    label="Address Line 2"
                    variant="outlined"
                    fullWidth
                    size="small"
                    name="addresslinE2"
                    disabled={suprefcode === 0}
                    required
                    value={selectedbranch.addresslinE2}
                    onChange={handleBranchInputChange}
                    error={!!errorsup.addresslinE2}
                    helperText={errorsup.addresslinE2}
                    FormHelperTextProps={{
                      sx: { fontSize: "12px", color: "red" }, // Customize font size and color
                    }}
                  />
                </Grid>
                <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                  <TextField
                    id="address1"
                    label="Address Line 3"
                    variant="outlined"
                    fullWidth
                    size="small"
                    name="addresslinE3"
                    disabled={suprefcode === 0}
                    value={selectedbranch.addresslinE3}
                    onChange={handleBranchInputChange}
                    error={!!errorsup.addresslinE3}
                    helperText={errorsup.addresslinE3}
                    FormHelperTextProps={{
                      sx: { fontSize: "12px", color: "red" }, // Customize font size and color
                    }}
                  />
                </Grid>
                <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
                  <TextField
                    label="Email"
                    variant="outlined"
                    fullWidth
                    size="small"
                    required
                    name="email"
                    disabled={suprefcode === 0}
                    value={selectedbranch.email}
                    onChange={handleBranchInputChange}
                    error={!!errorsup.email}
                    helperText={errorsup.email}
                    FormHelperTextProps={{
                      sx: { fontSize: "12px", color: "red" }, // Customize font size and color
                    }}
                  />
                </Grid>
                <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
                  <TextField
                    label="Contact Number"
                    variant="outlined"
                    fullWidth
                    size="small"
                    required
                    name="contactno"
                    disabled={suprefcode === 0}
                    value={selectedbranch.contactno}
                    onChange={handleBranchInputChange}
                    error={!!errorsup.contactno}
                    helperText={errorsup.contactno}
                    FormHelperTextProps={{
                      sx: { fontSize: "12px", color: "red" }, // Customize font size and color
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Box>
          <Box sx={styles.add_form_page_button_box}>
            <Button
              variant="outlined"
              size="medium"
              sx={{ ...styles.btn_secondary, ...styles.btn_add_cancel }}
              onClick={handleBranchClear}
            >
              Clear
            </Button>
            <Button
              variant="contained"
              size="medium"
              sx={{ ...styles.btn_primary, ...styles.btn_add_confirm }}
              onClick={handleBranchConfirmClick}
            >
              Add
            </Button>
          </Box>
          <Box sx={styles.view_page_container}>
            <Typography sx={styles.supplier_sub_title_text}>
              Supplier Branch Details
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <ViewDataGridGrn
              columns={supplierBranchData.columns}
              rows={(datasupbranch || []).map((row) => ({
                ...row,
                id: row.supbranchcode || Math.random(),
              }))}
              getRowId={(row) => row.id} // Use the id property for unique identification
              menuItems={menuItems}
              tabletitle={supplierBranchData.name}
              gridid="supbranchcode"
              sx={styles.view_data_grid_page}
            />
          </Box>
        </>
      )}
    </>
  );
}

export default SupplierBasicInfo;
